module.exports = __webpack_public_path__ + "static/card3-92ccce7d4f5e232b653378cc889c4767.png";